export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-random/src/defaultSource.js
// module id = ../../../../d3-random/src/defaultSource.js
// module chunks = 3